var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 11.4 11.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.24,
    y: 0.24,
    width: 10.92,
    height: 10.92,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.61,
    y: 1.61,
    width: 8.19,
    height: 8.19,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/GLOBAL.63e2103fe04ee110242015dd8480d202.svg";
export { ForwardRef as ReactComponent };